require("bootstrap-daterangepicker/daterangepicker.css");

import 'bootstrap-daterangepicker';
import moment from "moment";

function enableDateFields($scope) {
  function clearDate(event) {

    // don't submit the form.
    event.preventDefault();

    // find a bunch of relevant elements.
    var $dateField = $(event.target).closest('.date-input').find('input');

    // clear the cloudinary id.
    $dateField.val(null);

  }

  $scope.find('input.single-daterange:not(.past-only)').daterangepicker({
    showDropdowns: true,
    minYear: 1980,
    // maxYear: 2020,
    singleDatePicker: true,
    autoUpdateInput: false,
    locale: {
      cancelLabel: 'Clear',
      format: 'DD/MM/YYYY',
    }
  });

  $scope.find('input.single-daterange:not(.past-only)').on('apply.daterangepicker', function(ev, picker) {
    $(this).val(picker.startDate.format('DD/MM/YYYY'));
  });

  $scope.find('input.single-daterange:not(.past-only)').on('cancel.daterangepicker', function(ev, picker) {
    $(this).val('');
  });

  // date picker for past dates only
  const $pastOnlyDateFields = $scope.find('input.single-daterange.past-only');

  $pastOnlyDateFields.daterangepicker({
    minYear: moment().subtract(10, 'years').year(),
    maxYear: moment().year(),
    maxDate: moment().endOf('day'),
    singleDatePicker: true,
    autoUpdateInput: true,
    autoApply: true,
    showDropdowns: true,
    locale: {
      cancelLabel: 'Clear',
      format: 'DD/MM/YYYY',
    }
  });
  $pastOnlyDateFields.on('apply.daterangepicker', function(ev, picker) {
    $(this).val(picker.startDate.format('DD/MM/YYYY'));
  });
  $pastOnlyDateFields.on('cancel.daterangepicker', function(ev, picker) {
    $(this).val('');
  });

  $scope.find(".date-input button.clear").click(clearDate);
}

$(document).on('turbolinks:load', function() {
  enableDateFields($('body'));
})

$(document).on('sprinkles:update', function(event) {
  enableDateFields($(event.target));
})
